import {localizeI18nObj} from "./i18n";

export const PUBLIC_HUB_EXTRAS = [
  "MapLayer",
  "TreePageSize",
  "HeaderLogoSmallURL",
  "HeaderLogoAlt",
  "HeaderLogoHref",
  "headerLogoTitle",
  "DisableArtefactsCache",
  "CustomColors",
  "Footer",
  "Registration",
  "Access",
  "Style",
  "Translations"
];
export const PUBLIC_NODE_EXTRAS = [
  "HiddenAttributes",
  "DownloadFormats",
  "DefaultLastNPeriods",
  "QueryInfo",
  "TimePeriodRangeStart",
  "TimePeriodRangeEnd",
  "TimePeriodFormatYear",
  "TimePeriodFormatMonth",
  "TimePeriodFormatDay",
  "TimePeriodFormatQuarter",
  "TimePeriodFormatSemester",
  "TimePeriodFormatQuadrimester",
  "TimePeriodFormatDate",
  "TimePeriodFormatTime",
  "HideLabelOnCategoryWithImage",
  "HierarchyOnlyAttributes",
  "HideHierarchyOnlyRows",
  "SupportedLanguages",
  "DefaultLanguage",
  "ChartsSettings",
  "ShowHubDashboards",
  "CustomColors",
  "StatsManagerBaseUrl"
];

const getParsedExtras = (extrasList, prefLang, langs) => {
  const parsedExtras = {};

  (extrasList ?? []).forEach(({key, value, values}) => {
    let parsedValue;

    const tmpValue = values ? localizeI18nObj(values, prefLang, langs) : value;

    try {
      parsedValue = JSON.parse(tmpValue);
    } catch (e) {
      parsedValue = tmpValue;
    }
    parsedExtras[key] = parsedValue;
  });

  return parsedExtras;
};

const getSerializedExtras = (extrasDictionary, publicKeys = []) => {
  const serializedDictionary = [];

  Object.keys(extrasDictionary ?? {}).forEach(key => {
    const value = extrasDictionary[key];
    if (value !== null && value !== undefined) {
      serializedDictionary.push({
        key: key,
        value: JSON.stringify(value),
        isPublic: publicKeys.includes(key)
      });
    }
  });

  return serializedDictionary;
};

const EXTRAS = {
  parse: getParsedExtras,
  serialize: getSerializedExtras
};

export default EXTRAS;
